import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiBackgroundConfig } from '@/data/landingConfig/landingAiBackgroundConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiBackground } from './schemaObject';

interface Props {}
const AiBackground: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiBackground} />
			<LandingTemplate
				data={landingAiBackgroundConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAIBackground()}
			/>
		</>
	);
};

export default AiBackground;
